<div class="d-flex align-items-center">
  <div
    class="c-field-value__shape-circle -sale-status mr-6"
    [ngClass]="{
      '-active': statusCode === 1,
      '-paused': statusCode === 3,
      '-blocked': statusCode === 2,
      '-pending': statusCode === 0
    }"
  ></div>
  <gtd-ui-field-default-string-or-empty [data]="status"></gtd-ui-field-default-string-or-empty>
</div>
